(function () {
  function refreshHeaderCartIcon() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;

    fetch(root + '?section_id=cart-icon-bubble')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sectionEl = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('[id^="shopify-section-"]');
        if (sectionEl) link.innerHTML = sectionEl.innerHTML;
      })
      .catch(function () {});
  }

  function getComponents(root) {
    var el = root.querySelector('[data-zeitgeist-bundle-components]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // Reads the live selected Zeitgeist variant from the main variant picker above,
  // so the bundle reflects whatever color the customer currently has selected —
  // falling back to the variant this module was rendered with.
  function currentBaseVariantId(root) {
    var infoContainer = root.closest('.product__info-container') || document;
    var variantSelects = infoContainer.querySelector('variant-selects');
    var script = variantSelects ? variantSelects.querySelector('[data-selected-variant]') : null;
    if (script) {
      try {
        var parsed = JSON.parse(script.textContent);
        if (parsed && parsed.id) return String(parsed.id);
      } catch (e) {}
    }
    return root.dataset.baseVariantId;
  }

  function syncZeitgeistThumb(root) {
    var img = root.querySelector('[data-zeitgeist-thumb-img]');
    var components = getComponents(root);
    if (!img || !components) return;
    var info = components.zeitgeist.variants[currentBaseVariantId(root)];
    if (info && info.image) img.src = info.image;
  }

  function initBundle(root) {
    // Always re-sync the Zeitgeist thumbnail, even on nodes we've already
    // initialized — the main variant picker can re-render around this module
    // without necessarily replacing it, so this needs to run every time.
    syncZeitgeistThumb(root);

    if (root.dataset.zeitgeistBundleReady === 'true') return;
    root.dataset.zeitgeistBundleReady = 'true';

    var bundleVariantId = root.dataset.bundleVariantId;
    var addons = root.querySelectorAll('[data-zeitgeist-addon]');
    var ctaButton = root.querySelector('[data-zeitgeist-bundle-submit]');
    var partnerVariantSelect = root.querySelector('[data-zeitgeist-partner-variant-select]');
    var holdFastThumbImg = root.querySelector('[data-holdfast-thumb-img]');
    var infoContainer = root.closest('.product__info-container') || document;
    var quantityInput = infoContainer.querySelector('.quantity__input, input[name="quantity"]');

    function selectedQuantity() {
      var value = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    function selectedPurchaseOption() {
      var checked = root.querySelector('[data-zeitgeist-bundle-radio]:checked');
      return checked ? checked.value : 'bundle';
    }

    function updateHoldFastThumb() {
      var components = getComponents(root);
      if (!holdFastThumbImg || !partnerVariantSelect || !components) return;
      var info = components.holdFast.variants[partnerVariantSelect.value];
      if (info && info.image) holdFastThumbImg.src = info.image;
    }

    if (partnerVariantSelect) {
      partnerVariantSelect.addEventListener('change', updateHoldFastThumb);
    }

    function selectedAddonVariantIds() {
      var result = [];
      addons.forEach(function (addon) {
        var checkbox = addon.querySelector('[data-zeitgeist-addon-checkbox]');
        if (!checkbox || !checkbox.checked) return;
        var select = addon.querySelector('[data-zeitgeist-addon-variant-select]');
        result.push(select ? select.value : checkbox.dataset.variantId);
      });
      return result;
    }

    addons.forEach(function (addon) {
      var checkbox = addon.querySelector('[data-zeitgeist-addon-checkbox]');
      var variants = addon.querySelector('[data-zeitgeist-addon-variants]');

      function syncVariants() {
        if (!variants) return;
        variants.classList.toggle('is-expanded', !!(checkbox && checkbox.checked));
      }

      if (checkbox) checkbox.addEventListener('change', syncVariants);
      syncVariants();
    });

    if (ctaButton) {
      ctaButton.addEventListener('click', function () {
        if (ctaButton.getAttribute('aria-disabled') === 'true') return;

        var components = getComponents(root);
        var option = selectedPurchaseOption();
        var baseVariantIdNow = currentBaseVariantId(root);
        var bundleItem = { id: option === 'single' ? baseVariantIdNow : bundleVariantId, quantity: selectedQuantity() };

        if (option === 'bundle' && components) {
          var zeitgeistVariant = components.zeitgeist.variants[baseVariantIdNow] || {};
          var holdFastVariant = (partnerVariantSelect && components.holdFast.variants[partnerVariantSelect.value]) || {};

          var zeitgeistLabel = zeitgeistVariant.title
            ? components.zeitgeist.title + ' - ' + zeitgeistVariant.title
            : components.zeitgeist.title;
          var holdFastLabel = holdFastVariant.title
            ? components.holdFast.title + ' - ' + holdFastVariant.title
            : components.holdFast.title;

          var properties = {
            _bundle_items_count: '2',
            _bi_0_title: components.zeitgeist.title,
            _bi_0_variant: zeitgeistVariant.title || '',
            _bi_0_image: zeitgeistVariant.image || '',
            _bi_1_title: components.holdFast.title,
            _bi_1_variant: holdFastVariant.title || '',
            _bi_1_image: holdFastVariant.image || '',
          };
          properties[components.zeitgeist.title] = zeitgeistLabel;
          properties[components.holdFast.title] = holdFastLabel;
          properties['_bundle_selection'] = zeitgeistLabel + ' <> ' + holdFastLabel;
          bundleItem.properties = properties;
        }

        var items = [bundleItem];
        selectedAddonVariantIds().forEach(function (variantId) {
          items.push({ id: variantId, quantity: 1 });
        });

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var bodyData = { items: items };
        if (cart) {
          bodyData.sections = cart.getSectionsToRender().map(function (s) {
            return s.id;
          });
          bodyData.sections_url = window.location.pathname;
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }

        ctaButton.setAttribute('aria-disabled', 'true');
        ctaButton.classList.add('loading');

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(bodyData),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            return res.json();
          })
          .then(function (response) {
            if (typeof window.SLIDECART_UPDATE === 'function') {
              window.SLIDECART_UPDATE(function () {
                if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
                refreshHeaderCartIcon();
              });
            } else if (cart) {
              cart.classList.remove('is-empty');
              cart.renderContents(response);
              refreshHeaderCartIcon();
            } else {
              refreshHeaderCartIcon();
            }
          })
          .catch(function () {})
          .finally(function () {
            ctaButton.removeAttribute('aria-disabled');
            ctaButton.classList.remove('loading');
          });
      });
    }
  }

  function setupAll(scope) {
    (scope || document).querySelectorAll('[data-zeitgeist-bundle]').forEach(initBundle);
  }

  setupAll();

  // The main variant picker re-renders the product info column on change
  // (Dawn's standard AJAX section refresh), which can replace this module's
  // markup wholesale — watch for that and re-run setup so listeners stay
  // attached and the Zeitgeist thumbnail keeps tracking the selected color.
  var infoContainers = document.querySelectorAll('.product__info-container');
  if (window.MutationObserver && infoContainers.length) {
    infoContainers.forEach(function (container) {
      new MutationObserver(function () {
        setupAll(container);
      }).observe(container, { childList: true, subtree: true });
    });
  }
})();
